import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { SubmissionStatus, TalkStatus } from "src/common/types";
import { dateWithoutTime, displayDate } from "src/helpers";

const useStyles = makeStyles({
  completed: {
    color: "#1cac67"
  },
  default: {
    color: "#707070"
  },
  pending: {
    color: "#CF1F1F"
  }
});

interface IProps {
  date: Date;
  status: TalkStatus | SubmissionStatus;
  type: "talk" | "questionnaire";
}

const DashboardDateLabel = ({ date, status, type }: IProps) => {
  const classes = useStyles();

  const classNames = React.useMemo(() => {
    const currentDate = dateWithoutTime(new Date());
    if (dateWithoutTime(date) < currentDate) {
      return (type === "questionnaire" && status === SubmissionStatus.Submitted) ||
        (type === "talk" && status === TalkStatus.Done)
        ? classes.completed
        : classes.completed;
    } else {
      return classes.default;
    }
  }, [type, status, date]);

  return (
    <Typography variant="body1" display="inline" className={classNames}>
      {displayDate(date)}
    </Typography>
  );
};

export default React.memo(DashboardDateLabel);
